import axios from '../../axios';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_SIGNIN } from '../types';

import { login, logout } from '../../utils/auth.js';
import { setAlert } from './alert';
import { toast } from 'react-toastify';

// User Login
export const authLogin = (props, data) => async (dispatch) => {
   try {
      const res = await axios.post('/user/login', data);
      if (res.data.code === 1) {
         const user = {
            access_token: res.data.access_token,
            refresh_token: res.data.refresh_token,
         };
         login(user);
         // localStorage.setItem('email', data.email);
         // localStorage.setItem('password', data.password);
         localStorage.setItem('authTokenCustomer', JSON.stringify(user));
         dispatch({ type: AUTH_LOGIN, payload: user });
         if (res.data && res?.data?.loginHistory) localStorage.setItem('companyId', res.data?.loginHistory?.companyId);
         const redirectPath = res.data.isCompany ? '/admin/default' : '/auth/create-comp';
         props(redirectPath);
         setTimeout(() => {
            toast.success('Login successful!');
         }, 500);
      }
      return res.data;
      // else {
      //   dispatch({ type: AUTH_ERROR, payload: res.data.message });
      //   toast.error('Login failed! Please try again.');
      // }
   } catch (err) {
      dispatch({ type: AUTH_ERROR, payload: err.message });
      dispatch(setAlert(err.message, 'danger'));
      toast.error(err.response.data.message);
   }
};



export const authSignIn =
   (data, options = {}) =>
   async (dispatch) => {
      try {
         const res = await axios.post('/user/login', data);
         if (res.data.code === 1) {
            const user = {
               access_token: res.data.access_token,
               refresh_token: res.data.refresh_token,
            };
            login(user);
            localStorage.setItem('email', data.email);
            dispatch({ type: AUTH_SIGNIN, payload: user });
            localStorage.setItem('authCodeCustomer', data.code);
            if (res.data && res?.data?.loginHistory)
               localStorage.setItem('companyId', res.data?.loginHistory?.companyId);
            if (!options.skipRedirect) {
               const redirectPath = res.data.isCompany ? '/admin/default' : '/auth/create-comp';
               // props(redirectPath); // Commented out as props is not defined
            }
            setTimeout(() => {
               toast.success('Sign in successful!');
            }, 500);
         }
      } catch (err) {
         dispatch({ type: AUTH_ERROR, payload: err.message });
         dispatch(setAlert(err.message, 'danger'));
         toast.error('Sign in failed! Please try again.');
      }
   };

// User Logout
export const authLogout = () => async (dispatch) => {
   try {
      logout();
      dispatch({ type: AUTH_LOGOUT, payload: '' });
      dispatch(setAlert('Logout done', 'success'));
   } catch (err) {
      dispatch({ type: AUTH_ERROR, payload: err.message });
      dispatch(setAlert(err.message, 'danger'));
   }
};
